export const environment = {
  crmOrigin: 'https://c2bdev.production.am',
  api: {
    external: 'https://c2bapidev.production.am/api/v1/external/',
    frontend: 'https://c2bapidev.production.am/api/v1/frontend/',
    admin: 'https://c2bapidev.production.am/api/v1/admin/',
  },
} as const;
